export const InputValidations = values => {
  const errors = {}

  if (!values.firstName) {
    errors.firstName = "Required"
  } else if (values.firstName.length <= 1) {
    errors.firstName = "Must be a little longer than that"
  }

  if (!values.secondName) {
    errors.secondName = "Required"
  } else if ( values.secondName.length <= 1 ) {
    errors.secondName = "Must be a little longer than that"
  }

  if (!values.email) {
    errors.email = "Required"
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address"
  }

  if (!values.phoneNumber) {
    errors.phoneNumber = "Required"
  } else if (
    !/^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/i.test(
      values.phoneNumber
    )
  ) {
    errors.phoneNumber = "Invalid phone number"
  }

  if (!values.password) {
    errors.password = "Required"
  } else if (
    !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
      values.password
    )
  ) {
    errors.password =
      "Minimum eight characters, at least one uppercase letter, one lowercase letter and one number"
  }

  if (!values.passwordValidation) {
    errors.passwordValidation = "Required"
  } else if (
    !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
      values.passwordValidation
    )
  ) {
    errors.passwordValidation =
      "Minimum eight characters, at least one uppercase letter, one lowercase letter and one number"
  } else if (values.password !== values.passwordValidation) {
    errors.passwordValidation = "Passwords must be the same"
  }

  if (!values.jobReferenceNumber) {
    errors.jobReferenceNumber = "Required"
  }

  if (!values.roleProductionCompany) {
    errors.roleProductionCompany = "Required"
  } else if ( values.roleProductionCompany.length <= 1 ) {
    errors.roleProductionCompany = "Must be a little longer than that"
  }

  if ( parseInt( values.crewSize ) === 0 ) {
    errors.crewSize = "Required"
  }

  if (!values.termsAgreed) {
    errors.termsAgreed = "Required"
  }

  return errors
}

export default InputValidations
